import {
    animate, state, style, transition, trigger,
} from '@angular/animations';
import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'expansion-content',
    templateUrl: './expansion-content.component.html',
    styleUrl: './expansion-content.component.scss',
    animations: [
        trigger('expandCollapse', [
            state('collapsed', style({ height: '0px', overflow: 'hidden', opacity: 0 })),
            state('expanded', style({ height: '*', overflow: 'hidden', opacity: 1 })),
            transition('collapsed <=> expanded', [
                animate('300ms ease-in-out'),
            ]),
        ]),
    ],
    imports: [
        MatIcon,
        NgClass,
        NgIf,
    ],
})
export class ExpansionContentComponent {
    /**
     * Class input to add to the chevron-down <mat-icon>
     */
    @Input() iconClass = 'text-app-global-text-secondary';

    /**
     * Is expanded
     */
    @Input() expanded = false;

    /**
     * Is initialized
     */
    initialized = false;

    /**
     * Toggle state between expanded and collapsed
     */
    toggleExpand(): void {
        this.expanded = !this.expanded;
    }

    /**
     * Handle after view init
     */
    ngAfterViewInit(): void {
        // Wait one rendering cycle for ng-content to load
        setTimeout(() => {
            this.initialized = true;
        });
    }
}
